import { IModuleNavigationData } from './navigation';
import { IAgentPromptLogReference } from './agentPromptLog';

export enum AIIllustrationJobStatus {
  PENDING = 0,
  RUNNING = 1,
  DONE = 2,
}

export enum AIIllustrationItemStatus {
  PENDING = 0,
  PROCESSING = 1,
  DONE = 2,
  ERROR = 3,
  NEEDS_REVIEW = 4,
}

export interface IAIIllustrationListItem {
  id: number;
  name: string;
  status: AIIllustrationJobStatus;
  status_text: string;
  category_id: number;
  category_name: string;
  created_by: string;
  created_by_id: number;
  created_at: string;
  progress: string;
  total_items: number;
  done_items: number;
  error_items: number;
  params: Record<string, any> | null;
}

export interface IAIIllustrationEdit extends IAIIllustrationListItem {
  items?: IAIIllustrationItem[];
}

export interface IAIIllustrationItem {
  id: number;
  job_id: number;
  voc_id: number;
  voc_title: string;
  status: AIIllustrationItemStatus;
  status_text: string;
  processing_alternatives: number[];
  async_task_id: number | null;
  async_task_status: number;
  async_task_status_text: string;
  original_png: string | null;
  alternative_1: string | null;
  alternative_2: string | null;
  enhanced_results: {
    alternatives: Array<{
      number: number;
      path: string;
      url: string;
    }>;
    opaque_alternatives?: Array<{
      number: number;
      url: string;
      status: string;
    }>;
    generated_at: string;
    approved_alternative?: number;
    approved_at?: string;
  } | null;
  opaque_alternatives: Record<number, string | null>;
  error_message: string | null;
  created_at: string;
  updated_at: string;
  navigation_data: IModuleNavigationData;
  agent_prompt_log: IAgentPromptLogReference | null;
}

export interface IAIIllustrationCreate {
  name: string;
  voc_category_id: number;
}

export interface IVocCategory {
  id: number;
  category: string;
  description: string;
}

// AG-Grid cell renderer parameter types
export interface AIIllustrationStatusCellParams {
  value?: AIIllustrationItemStatus | number | string | null;
}

export interface AIIllustrationJobStatusCellParams {
  value?: AIIllustrationJobStatus | number | string | null;
}

export interface ImageUrlCellParams {
  value?: string | null;
}
